var map = {
  "./applications.json": "62543",
  "./apps.json": "30728",
  "./attachment_relations.json": "79359",
  "./boarding.json": "83992",
  "./calendar.json": "77282",
  "./common.json": "39781",
  "./customizable_table.json": "2403",
  "./dashboard.json": "55820",
  "./job_ads.json": "20754",
  "./layouts.json": "80095",
  "./mailer.json": "52332",
  "./modules.json": "16589",
  "./news.json": "6167",
  "./payments.json": "56751",
  "./permission_presets.json": "97828",
  "./posting_orders.json": "12958",
  "./search.json": "46092",
  "./skills.json": "93726",
  "./statistics.json": "62691",
  "./support.json": "90607",
  "./time_tracking.json": "69719",
  "./wizard_settings.json": "96585"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 5201;
